import { type ReactElement } from 'react';
import {
    IconBell,
    IconBxsCube,
    IconCart,
    IconCashback,
    IconChat,
    IconDocPost,
    IconDocSite,
    IconDocument,
    IconDocumentError,
    IconGift,
    IconGrid,
    IconGridFrame,
    IconHeart,
    IconJob,
    IconMail,
    IconMoney,
    IconSearch,
    IconShoppingBag,
    IconUser,
} from '@direct-frontend/components';
import {
    CONSTRUCTOR_404_PAGE_ALIAS,
    CONSTRUCTOR_ACCOUNT_LOYALTY_ALIAS,
    CONSTRUCTOR_ACCOUNT_NEWSLETTERS_ALIAS,
    CONSTRUCTOR_ACCOUNT_ORDERS_ALIAS,
    CONSTRUCTOR_ACCOUNT_PROFILE_ALIAS,
    CONSTRUCTOR_ACCOUNT_REFUNDS_ALIAS,
    CONSTRUCTOR_BLOG_ALIAS,
    CONSTRUCTOR_BLOG_ENTRY_ALIAS,
    CONSTRUCTOR_CART_ALIAS,
    CONSTRUCTOR_CART_PREVIEW_ALIAS,
    CONSTRUCTOR_CATALOG_ALIAS,
    CONSTRUCTOR_CATEGORY_AND_COLLECTION_ALIAS,
    CONSTRUCTOR_DELIVERY_ALIAS,
    CONSTRUCTOR_DETAILS_ALIAS,
    CONSTRUCTOR_DISCOUNT_LADDER_ALIAS,
    CONSTRUCTOR_FAVOURITE_PRODUCTS_ALIAS,
    CONSTRUCTOR_GIFT_CARD_ALIAS,
    CONSTRUCTOR_GIFT_CARD_QUESTIONS_ALIAS,
    CONSTRUCTOR_LOYALTY_LANDING_ALIAS,
    CONSTRUCTOR_LOYALTY_OFFER_ALIAS,
    CONSTRUCTOR_MAIN_PAGE_ALIAS,
    CONSTRUCTOR_OFFER_ALIAS,
    CONSTRUCTOR_PAYMENT_ALIAS,
    CONSTRUCTOR_PRIVACY_ALIAS,
    CONSTRUCTOR_PRODUCT_CARD_ALIAS,
    CONSTRUCTOR_PRODUCT_REVIEWS_ALIAS,
    CONSTRUCTOR_PRODUCTS_BUNDLE_ALIAS,
    CONSTRUCTOR_RETURN_ALIAS,
    CONSTRUCTOR_SEARCH_ALIAS,
    CONSTRUCTOR_SUBSCRIPTION_ALIAS,
    CONSTRUCTOR_UNSUBSCRIBE_ALIAS,
} from '../constants';

export const CONSTRUCTOR_PAGE_ICON_MAP: Record<string, ReactElement> = {
    default: <IconDocument color="gray" />,
    [CONSTRUCTOR_MAIN_PAGE_ALIAS]: <IconDocPost color="gray" />,
    [CONSTRUCTOR_PRODUCT_CARD_ALIAS]: <IconBxsCube color="gray" />,
    [CONSTRUCTOR_PRODUCT_REVIEWS_ALIAS]: <IconChat color="gray" />,
    [CONSTRUCTOR_CATALOG_ALIAS]: <IconGridFrame color="gray" />,
    [CONSTRUCTOR_CATEGORY_AND_COLLECTION_ALIAS]: <IconGrid color="gray" />,
    [CONSTRUCTOR_SEARCH_ALIAS]: <IconSearch color="gray" />,
    [CONSTRUCTOR_CART_ALIAS]: <IconCart color="gray" />,
    [CONSTRUCTOR_CART_PREVIEW_ALIAS]: <IconCart color="gray" />,
    [CONSTRUCTOR_FAVOURITE_PRODUCTS_ALIAS]: <IconHeart color="gray" />,
    [CONSTRUCTOR_BLOG_ALIAS]: <IconDocSite color="gray" />,
    [CONSTRUCTOR_BLOG_ENTRY_ALIAS]: <IconDocSite color="gray" />,
    [CONSTRUCTOR_404_PAGE_ALIAS]: <IconDocumentError color="gray" />,

    [CONSTRUCTOR_PRIVACY_ALIAS]: <IconJob color="gray" />,
    [CONSTRUCTOR_PAYMENT_ALIAS]: <IconJob color="gray" />,
    [CONSTRUCTOR_DELIVERY_ALIAS]: <IconJob color="gray" />,
    [CONSTRUCTOR_RETURN_ALIAS]: <IconJob color="gray" />,
    [CONSTRUCTOR_DETAILS_ALIAS]: <IconJob color="gray" />,
    [CONSTRUCTOR_OFFER_ALIAS]: <IconJob color="gray" />,

    [CONSTRUCTOR_GIFT_CARD_ALIAS]: <IconGift color="gray" />,
    [CONSTRUCTOR_GIFT_CARD_QUESTIONS_ALIAS]: <IconGift color="gray" />,

    [CONSTRUCTOR_LOYALTY_LANDING_ALIAS]: <IconCashback color="gray" />,
    [CONSTRUCTOR_LOYALTY_OFFER_ALIAS]: <IconCashback color="gray" />,

    [CONSTRUCTOR_ACCOUNT_LOYALTY_ALIAS]: <IconCashback color="gray" />,
    [CONSTRUCTOR_ACCOUNT_NEWSLETTERS_ALIAS]: <IconBell color="gray" />,
    [CONSTRUCTOR_ACCOUNT_ORDERS_ALIAS]: <IconShoppingBag color="gray" />,
    [CONSTRUCTOR_ACCOUNT_PROFILE_ALIAS]: <IconUser color="gray" />,
    [CONSTRUCTOR_ACCOUNT_REFUNDS_ALIAS]: <IconMoney color="gray" />,

    [CONSTRUCTOR_PRODUCTS_BUNDLE_ALIAS]: <IconDocSite color="gray" />,
    [CONSTRUCTOR_DISCOUNT_LADDER_ALIAS]: <IconDocSite color="gray" />,
    [CONSTRUCTOR_SUBSCRIPTION_ALIAS]: <IconMail color="gray" />,
    [CONSTRUCTOR_UNSUBSCRIBE_ALIAS]: <IconMail color="gray" />,
};

export const getConstructorPageIcon = (alias: string | number = 'default') =>
    CONSTRUCTOR_PAGE_ICON_MAP[alias] ?? CONSTRUCTOR_PAGE_ICON_MAP.default;
